let instance = null;

export function registerInstance(ref) {
  instance = ref;
}

export function show(devices, onSelect) {
  if (!instance) {
    console.error("PopupDevicesComponent não está montado.");
    return;
  }
  instance.open(devices, onSelect);
}

export function close() {
  if (instance) {
    instance.close();
  }
}
